import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';

import Icon from '@material-ui/core/Icon';
import Hidden from '@material-ui/core/Hidden';

import CustomDialog from './inputs/CustomDialog'
// import ProspectPreview from './ProspectPreview'
import InstaTable from './InstaTable'

import {
  prospects_index,
  resend_preregistration,
  delete_prospect,
  prospects_xlsx,
  set_path,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals } = state.prospect
  return {
    prospect: state.prospect,
    prospects: items,
    pagination: pagination,
    totals: totals,
    current_user: state.auth.current_user.data,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getProspects: (page=1, per_page=10, filters={}, sort='', order='', user_type="user") => dispatch( prospects_index(page, per_page, filters, sort, order, user_type) ),
    prospectsXLSX: (filters={}, sort='', order='', user_type="user") => dispatch( prospects_xlsx(filters, sort, order, user_type) ),
    setPath: path => dispatch( set_path(path) ),
    deleteProspect: (prospect_id, page=1, per_page=10, filters={}, sort='', order='', user_type="user") => dispatch( delete_prospect(prospect_id, page, per_page, filters, sort, order, user_type) ),
    resendInvitation: (prospect_id, user_type = 'user') => dispatch( resend_preregistration(prospect_id, user_type) ),
  }
}

class ConnectedProspectsIndex extends React.Component {
  state={
    current_prospect: {},
    current_view: 'all',
    init_filters: {},
    merge_filters: {},
    current_id: undefined,
    filterState: {},
    showDialog: false,
    mounted: false
  }

  fieldGetter(field, item, instate) {
    let renderText
    const state = {
      ...instate,
      filters: {
        ...instate.filters,
        ...this.state.merge_filters
      }
    }
    if (field === "created_at" || field === "last_reminder") {
      renderText = item[field] ? new Date(item[field]).toLocaleDateString() : ''
    } else if (field === 'email') {
      renderText = item.email
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { this.resendInvitation(item) }
          { this.deleteProspect(item, state) }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getProspects, setPath, user_type } = this.props
    setPath( user_type === 'b2b' ? 'business_prospects' : 'prospects')

    getProspects(1, 10, {}, '', '', user_type)
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.prospect.fetching && !this.props.prospect.fetching && this.props.prospect.fetched) {
        this.setState({mounted: true})
      }
    }
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  resendInvitation = item => {
    const {id} = item
    return (
      <Link to="" className="action-btn" title="Send Activation Reminder" onClick={ e=> {
        e.preventDefault()
        this.props.resendInvitation(id, this.props.user_type)
        // alert("Not firing yet :(")
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>send</Icon>
      </Link>
    )
  }

  deleteProspect = (item, state) => {
    const {id} = item
    return (
      <Link to="" className="action-btn" title="Delete Prospect" onClick={ e=> {
        e.preventDefault()
        this.setState({showDialog: true, current_id: id, filterState: state})
      }}>
        <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}}>delete_forever</Icon>
      </Link>
    )
  }

  destroy = id => {
    const {filters, sort, order, page, per_page} = this.state.filterState
    // console.log("this.state.filterState")
    // console.log(this.state.filterState)
    this.props.deleteProspect(id, page, per_page, filters, sort, order, this.props.user_type )
    this.hideDialog()
    this.setState({filterState: {}})
  }

  hideDialog = () => {
    this.setState({showDialog: false})
  }

  headerButton = (filters, sort, order) => {
    return (
      <Hidden smDown>
        <a href='' style={{float: 'right'}} onClick={e => {
          e.preventDefault()
          this.props.prospectsXLSX(filters, sort, order, this.props.user_type)
        }}>
          Download XLSX
        </a>
      </Hidden>
    )
  }


  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { role } = this.props.current_user

    if ( role !== 'admin' ) {
      return <Redirect to="/" />
    }

    const { prospects, pagination, totals } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'email', disablePadding: true, label: 'Email' },
      { id: 'created_at', disablePadding: true, label: 'Registration Date' },
      { id: 'last_reminder', disablePadding: true, label: 'Last Activation Reminder' },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "created_at", filter_type: "date" },
    ]

    const statuses = [
      { name: "all", label: "All", value: totals.all }
    ]

    return (
      <div id="prospects-wrapper" className={this.props.prospect.fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            Prospects
          </Typography>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={prospects}
          pagination={pagination}
          role={role}
          search={true}
          placeholders="Email"
          merge_filters={this.state.merge_filters}
          init_filters={this.state.init_filters}
          rowGetter={this.props.getProspects.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          classPrefix="prospects"
          addClassField="status"
          headerButton={this.headerButton.bind(this)}
        />

        <CustomDialog
          id="delete-dialog"
          fullScreen = {false}
          qid={this.state.current_id}
          isopen={this.state.showDialog}
          handleClose={this.hideDialog.bind(this)}
          handleAccept={this.destroy.bind(this)}
          title="Delete Prospect?"
        >
          This action cannot be undone
        </CustomDialog>
      </div>
    )
  }
}

const ProspectsIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedProspectsIndex)

export default withStyles(styles)(ProspectsIndex)



// WEBPACK FOOTER //
// ./src/js/components/ProspectsBase.js